import { Box } from "@mui/material";
import ProductImage from "../atoms/ProductImage";

const ProductDisplay = ({ product = {} }) => {
  console.log(product);
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "white",
        px: 2.5,
        py: 2,
        minHeight: "60px",
        gap: 1.5,
      }}
    >
      <Box>
        <ProductImage data={product} />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ fontSize: "13px", fontWeight: 700, letterSpacing: "0.25px", color: "#262338" }}>
          {product.display_name}
        </Box>
        <Box sx={{ fontSize: "11px", fontWeight: 500, letterSpacing: "0.25px", color: "#6E7191" }}>{product.size}</Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          flexGrow: 1,
        }}
      >
        <Box sx={{ fontSize: "13px", fontWeight: 600, letterSpacing: "0.25px", color: "#262338" }}>
          QTY: {product.qty}
        </Box>
        <Box sx={{ fontSize: "13px", fontWeight: 600, letterSpacing: "0.25px", color: "#262338" }}>
          ₱{(product.qty * product.price).toFixed(2)}
        </Box>
      </Box>
    </Box>
  );
};

export default ProductDisplay;
